import { render, staticRenderFns } from "./addcategory.vue?vue&type=template&id=61761fcf&"
import script from "./addcategory.vue?vue&type=script&lang=js&"
export * from "./addcategory.vue?vue&type=script&lang=js&"
import style0 from "./addcategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports